import React from 'react'
import SimplePopover from '@/components/weekdatepopover'
import './index.scss'

const WeekPopover = ({isFinish}) => {
    return (
        <div className="week-popover__box">
            {
                isFinish.map((item, index) => (
                    <div className="data-today" key={index}>
                        {item.activityFlag ? <i className="iconfont2 icon-duihao"></i> : ""}
                        <SimplePopover dateToday={item.date} turnover={`今日流水${item.payableAmount}元`} />
                    </div>
                ))
            }
        </div>
    )
}
export default WeekPopover
